export const VIEW_STATE: string = 'PLACE_BANNER_VIEW_STATE';
export const standartError: string = 'Ошибка авторизации';
